export function sendCodeIsLoading(bool) {
    return {
        type: "SEND_CODE_LOADING",
        isLoading: bool
    };
}
